import {
  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { WithChangesSubject } from 'core/mixins/with-changes-subject';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { GetEntityById2, GetEntityById2GQL } from 'generated/graphql';
import { FeatureFlagService } from 'feature-flags/feature-flag.service';

@Component({
  selector: 'app-entity-basic-card',
  templateUrl: './entity-basic-card.component.html',
})
export class EntityBasicCardComponent extends WithDisposableSubject(WithChangesSubject(class { })) implements OnInit, OnChanges {
  @Input() entityId: string;
  @Input() campaignId: string;
  @Input() withContactButtons = false;

  entity: GetEntityById2.GetEntity;

  constructor(
    private _getEntityGQL: GetEntityById2GQL,
    private _cd: ChangeDetectorRef,
    public _featureService: FeatureFlagService
  ) {
    super();
  }

  ngOnInit(): void {
    this.watchForChangeKeys('entityId', 'campaignId').pipe(
      startWith<any, any>(null),
      takeUntil(this.disposer),
      map(() => ({ campaignId: this.campaignId, entityId: this.entityId })),
      filter(({ campaignId, entityId }) => !!campaignId && !!entityId),
      switchMap(({ campaignId, entityId }) => this._getEntityGQL.watch({
        entityId, campaignId,
        withBestAddress: true,
        withToplines: false,
        withBestPhone: !!this.withContactButtons,
        withBestEmail: !!this.withContactButtons
      }, {
        fetchPolicy: 'cache-first'
      }).valueChanges),
      takeUntil(this.disposer),
      map(({ data }) => data?.getEntity)
    ).subscribe((entity) => {
      this.entity = entity;
      this._cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
